import {
  APP_SETTING_DELETE_PROJECT_PWA_CONFIG_BEGIN,
  APP_SETTING_DELETE_PROJECT_PWA_CONFIG_SUCCESS,
  APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE,
  APP_SETTING_DELETE_PROJECT_PWA_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteProjectPwaConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_PROJECT_PWA_CONFIG_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/pwa-config`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_DELETE_PROJECT_PWA_CONFIG_SUCCESS,
              data: res.data ? res.data : null,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteProjectPwaConfigError() {
  return {
    type: APP_SETTING_DELETE_PROJECT_PWA_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_PROJECT_PWA_CONFIG_BEGIN:
      return {
        ...state,
        deleteProjectPwaConfigPending: true,
        deleteProjectPwaConfigError: null,
      };

    case APP_SETTING_DELETE_PROJECT_PWA_CONFIG_SUCCESS:
      return {
        ...state,
        deleteProjectPwaConfigPending: false,
        deleteProjectPwaConfigError: null,
        projectDetail: action.data ? action.data : state.projectDetail,
      };

    case APP_SETTING_DELETE_PROJECT_PWA_CONFIG_FAILURE:
      return {
        ...state,
        deleteProjectPwaConfigPending: false,
        deleteProjectPwaConfigError: action.data.error,
      };

    case APP_SETTING_DELETE_PROJECT_PWA_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        deleteProjectPwaConfigError: null,
      };

    default:
      return state;
  }
}
